module.exports = __webpack_public_path__ + "01_face.361a7895.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/boy/layer1/01_face.png
// module id = 44Oz
// module chunks = 0